module.exports = __webpack_public_path__ + "static/img/son3_active.295bdc9e.png";